import script from "./lecture.vue?vue&type=script&setup=true&lang=js"
export * from "./lecture.vue?vue&type=script&setup=true&lang=js"

import "./lecture.vue?vue&type=style&index=0&id=240df2df&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-240df2df"]])

export default __exports__